import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ACTIVE_PATIENTS_KEY, GET_ALL_PATIENTS_KEY } from '_api/queries/patient';
import { Patient, PatientPayload } from '_api/types';

export const UPDATE_PATIENT_KEY = 'update-patient-key';

export const useUpdatePatient = () => {
  const queryClient = useQueryClient();
  return useApiMutation<Patient, PatientPayload>(
    () => '/patient',
    'put',
    {},
    {
      mutationKey: [UPDATE_PATIENT_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ACTIVE_PATIENTS_KEY] });
        queryClient.invalidateQueries({ queryKey: [GET_ALL_PATIENTS_KEY] });
      },
    },
  );
};
